import { useEffect } from "react";
import useWebSocket from "react-use-websocket";
import { Options } from "react-use-websocket/src/lib/types";
import { useImmer } from "use-immer";

import { WebsocketData } from "@intelligems/ig-types";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { useLoggedInUser } from "@src/api/user-auths/login";

import { getAuthToken } from "../utils";

export const useWebsocket = (
  opts?: Options,
  defaultUrl = import.meta.env.VITE_WEBSOCKET_URL
) => {
  const org = useGetOrg();
  const user = useLoggedInUser();
  const [url, setUrl] = useImmer<string | null>(null);

  const token = getAuthToken();

  useEffect(() => {
    if (org.data?.org?.id && user.data?.user?.email) {
      setUrl(`${defaultUrl}`);
    }
  }, [org.data?.org?.id, user.data?.user?.email]);

  // @ts-ignore
  return useWebSocket<WebsocketData>(
    org.data?.org?.id && user?.data?.user?.email && token ? url : null,
    {
      share: true,
      onError: (err: WebSocketEventMap["error"]) => {
        console.log(err);
      },
      shouldReconnect: (closeEvent) => true,
      queryParams:
        org.data?.org?.id && user.data?.user?.email && token
          ? {
              orgId: org.data?.org?.id,
              email: user.data.user.email,
              token,
            }
          : undefined,
      ...opts,
    }
  );
};
